(function ( $ ) {

    $.fn.initBanner = function() {
        return $(this).each(function(){
            var $that = $(this),
                $close = $that.find('.js-banner-close');

            if(!Cookies.get('boutiquehop')) {
                $that.addClass('open');
            }

            $close.on('click', function(e){
                e.stopPropagation();
                Cookies.set('boutiquehop', true);
                $that.removeClass('open');
            });
        });
    };

}( jQuery ));

$(function(){
    if($('.js-banner').length) {
        $('.js-banner').initBanner();
    }
});